import { render, staticRenderFns } from "./KidneyCancer.vue?vue&type=template&id=1f4f86f0"
import script from "./KidneyCancer.vue?vue&type=script&lang=js"
export * from "./KidneyCancer.vue?vue&type=script&lang=js"
import style0 from "./KidneyCancer.vue?vue&type=style&index=0&id=1f4f86f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports